import React, { useState } from 'react';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import chevronUp from '../../../../../assets/images/chevron-pointing-up.svg';
import chevronDown from '../../../../../assets/images/chevron-pointing-down.svg';

import './BeneficiaryListMobile.scss';

const BeneficiaryListMobileToggleTable = (beneInfo) => {
  const [showMobileViewPrimary, setShowMobileViewPrimary] = useState(false);
  const {
    distribution,
    entityType,
    relationship,
    taxId,
    dateOfBirth,
    entity,
    name,
  } = beneInfo.beneInfo;
  const displayName =
    entityType === 'entity'
      ? name
      : `${entity?.entityName.firstName} ${entity?.entityName.lastName}`;
  const entityTypeCapital =
    entityType?.charAt(0)?.toUpperCase() + entityType?.slice(1);
  const RelationshipCapital =
    relationship?.charAt(0)?.toUpperCase() + relationship?.slice(1);
  return (
    <div>
      <div className="mobile-only-title">
        <button
          className="chevron-button"
          onClick={() => setShowMobileViewPrimary(!showMobileViewPrimary)}
        >
          {!showMobileViewPrimary && (
            <img slot="icon" src={chevronDown} alt="" />
          )}
          {showMobileViewPrimary && <img slot="icon" src={chevronUp} alt="" />}
        </button>
        <div className="mobile-only-title-text">{displayName}</div>
        <div className="mobile-only-title-percentage">{distribution || 0}%</div>
      </div>
      {showMobileViewPrimary && (
        <table className="mobile-on-click">
          <tr className="mobile-on-expanded-view">
            Type: {entityType ? entityTypeCapital : '-'}
          </tr>
          <tr className="mobile-on-expanded-view">
            {RelationshipCapital ? RelationshipCapital : '-'}
          </tr>
          <tr className="mobile-on-expanded-view">
            SSN/TIN: {taxId ? taxId : '-'}
          </tr>
          <tr className="mobile-on-expanded-view">
            DOB: {dateOfBirth ? dateOfBirth : '-'}
          </tr>
        </table>
      )}
    </div>
  );
};

export default BeneficiaryListMobileToggleTable;
